import React from "react";
import { useLocation } from "react-router-dom";
import { getColumns } from "../../../components/crm/tables/Columns";
import { FormattedMessage } from "react-intl";
import { ReactComponent as ClientsImg } from "../../../assets/no-clients.svg";
import { Table, Empty } from "antd";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

const EventsTable = (props) => {
  const { onLaunchEntityModal, items } = props;
  const intl = useIntl();
  let location = useLocation();
  const dispatch = useDispatch();

  const loading = false;

  return (
    <Table
      loading={loading}
      rowKey={(record) => record.id}
      columns={getColumns("events_schedule", intl, location, dispatch, {
        onLaunchEntityModal,
      })}
      dataSource={items}
      scroll={{
        y: window.innerHeight - 450,
      }}
      bordered
      locale={{
        emptyText: (
          <Empty
            image={!loading ? <ClientsImg /> : null}
            description={
              !loading ? <FormattedMessage id={"app.tables.noData"} /> : null
            }
          />
        ),
      }}
    />
  );
};
export default EventsTable;
